<mat-form-field appearance="outline">
  @if (isLoading) {
    <mat-icon matPrefix class="loading">hourglass_top</mat-icon>
  } @else {
    <mat-icon matPrefix>search</mat-icon>
  }
  <mat-label>{{ label | translate }}</mat-label>
  <input
    matInput
    required
    [formControl]="searchControl"
    [matAutocomplete]="clientAutocomplete"
    [placeholder]="'clientSearch.placeholder' | translate"
  />
  <mat-autocomplete
    #clientAutocomplete="matAutocomplete"
    [displayWith]="displayClient"
    (optionSelected)="onClientSelected($event)"
  >
    @for (client of results; track client.nummer) {
      <mat-option [value]="client"> {{ client.naam }}, {{ client.nummer }} </mat-option>
    }
  </mat-autocomplete>
  <mat-hint>
    @if (loadError) {
      {{ 'clientSearch.error' | translate }}
    } @else if (isLoading) {
      {{ 'clientSearch.loading' | translate }}
    } @else if (noResults) {
      {{ 'clientSearch.noResults' | translate }}
    } @else {
      {{ 'clientSearch.hint' | translate }}
    }
  </mat-hint>
</mat-form-field>
